<div class="ion-padding">
  <ion-button class="big-text-btn" (click)="navigate()" [color]="b.buttoncolor == 'blue' ? 'primary' : 'success'"
    [innerHTML]="b.title"></ion-button>
</div>